import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import services from '../services';
import withResponseHandling from './withResponseHandling';
import withMessage from './withMessage';
import { acCarteirasChanged } from '../store/actions';

const PAGE_SIZE = 25;

const withAvaliacoesModelo = Component => {
  function WrapComponent(props) {
    const entidadeId = useSelector(state => state.entidade.current.default_entidade_id);
    const storeDispatch = useDispatch();

    const [modelos, setModelos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: PAGE_SIZE
    });

    function updateStore(pData) {
      storeDispatch(acCarteirasChanged(pData));
    }

    const readModelos = useCallback(
      async (pParams = {}, pCallback) => {
        if (!modelos.length) {
          setIsLoading(true);
        } else {
          setIsRefetching(true);
        }

        const xParams = {
          size: PAGE_SIZE,
          page: 1,
          sort: 'avaliacao_modelo_id desc',
          ...pParams
        };

        services.modelos.list(
          xParams,
          rRes => {
            const xModelos = Object.values(rRes.data || {});

            setModelos(xModelos);
            setRowCount(rRes.pages?.total_items || xModelos.length);
            pCallback && pCallback(xModelos);
          },
          rErr => {
            props.responseErrorHandling(rErr);
          },
          () => {
            setIsLoading(false);
            setIsRefetching(false);
          }
        );
      },
      [modelos.length, props]
    );

    const deleteModelos = (pModeloId, onFinish) => {
      services.modelos.remove(
        { avaliacao_modelo_id: pModeloId },
        () => {
          props.onMessageSuccess('Modelo excluído com sucesso');
          readModelos({}, updateStore);
          setRowSelection({});
        },
        rErr => {
          props.responseErrorHandling(rErr);
        },
        () => {
          onFinish && onFinish();
        }
      );
    };

    const bulkDeleteModelos = pRows => {
      const xModelosId = pRows.map(xRow => xRow.original.avaliacao_modelo_id).filter(Boolean);

      xModelosId.forEach(xId => {
        deleteModelos(xId);
      });
    };

    useEffect(() => {
      const xPage = pagination.pageIndex + 1;

      readModelos({
        page: xPage,
        size: pagination.pageSize
      });
    }, [readModelos, pagination.pageIndex, pagination.pageSize, entidadeId]);

    const xProps = {
      modelos,
      isLoading,
      isRefetching,
      rowCount,
      rowSelection,
      pagination,
      setPagination,
      setRowSelection,
      readModelos,
      deleteModelos,
      bulkDeleteModelos
    };

    return <Component {...xProps} />;
  }

  return withMessage(withResponseHandling(WrapComponent));
};

export default withAvaliacoesModelo;
